import { useQuery } from '@tanstack/react-query';
import { estimateApi } from '../api/estimate-service';
import { cacheKeys } from '@/shared/lib/cache-invalidation';

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Supported display currencies for the estimate currency switcher
 * (GET `/v1/currencies`). The catalog is static (USD first, then
 * alphabetical — server-ordered, rendered verbatim), so it is cached for a
 * day. `enabled` lets the caller defer the fetch until the switcher is
 * actually rendered.
 */
export function useCurrencies(enabled: boolean = true) {
  return useQuery({
    queryKey: cacheKeys.currencies,
    queryFn: () => estimateApi.listCurrencies(),
    enabled,
    staleTime: DAY_MS,
    gcTime: DAY_MS,
  });
}
